import React from 'react';
import AppUpsellBanner from './AppUpsellBanner';
import { useAppUpsell } from '@hooks/useAppUpsell';

/**
 * Mobile-app upsell banner for My Team pages. All gating lives in
 * useAppUpsell; this component only renders the banner.
 */
const AppUpsell = () => {
  const { isBannerVisible, storeUrl, ctaLabel, isAppView, dismiss } =
    useAppUpsell();

  if (!isBannerVisible) return null;

  return (
    <AppUpsellBanner
      storeUrl={storeUrl}
      ctaLabel={ctaLabel}
      onCtaClick={dismiss}
      onClose={dismiss}
      isAppView={isAppView}
    />
  );
};

export default AppUpsell;
